import React from 'react';
import { Box, Typography, Container, IconButton } from '@mui/material';
import { GitHub, LinkedIn, Twitter } from '@mui/icons-material';

const Footer = () => {
  return (
    // Box with primary color background and white text
    <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 3 }}>
      <Container>
        {/* Social media icons container */}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          {/* GitHub icon button */}
          <IconButton
            color="inherit"
            component="a"
            href="https://github.com/Cesarmoy-prog"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GitHub />
          </IconButton>
          {/* LinkedIn icon button */}
          <IconButton
            color="inherit"
            component="a"
            href="https://www.linkedin.com/in/cesar-moy-743061206/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedIn />
          </IconButton>
         
        </Box>
        {/* Copyright text */}
        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
          © {new Date().getFullYear()} Cesar Moy. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
